import {
  symRoundedAutorenew,
  symRoundedCancel,
  symRoundedCheckCircle,
  symRoundedDescription,
  symRoundedError,
  symRoundedImage,
  symRoundedPictureAsPdf,
  symRoundedSchedule,
  symRoundedStacks,
  symRoundedTouchApp,
} from '@quasar/extras/material-symbols-rounded'
import { AiQueueStatus } from '../types'

/**
 * Status color used consistently across tiles, table pills and the workbench.
 * Matches the StatusPill palette names.
 */
export const STATUS_COLOR: Record<AiQueueStatus, string> = {
  [AiQueueStatus.Pending]: 'warning',
  [AiQueueStatus.Processing]: 'info',
  [AiQueueStatus.AwaitingUserAction]: 'accent',
  [AiQueueStatus.Completed]: 'positive',
  [AiQueueStatus.Failed]: 'negative',
  [AiQueueStatus.Cancelled]: 'muted',
}

export const STATUS_ICON: Record<AiQueueStatus | 'all', string> = {
  all: symRoundedStacks,
  [AiQueueStatus.Pending]: symRoundedSchedule,
  [AiQueueStatus.Processing]: symRoundedAutorenew,
  [AiQueueStatus.AwaitingUserAction]: symRoundedTouchApp,
  [AiQueueStatus.Completed]: symRoundedCheckCircle,
  [AiQueueStatus.Failed]: symRoundedError,
  [AiQueueStatus.Cancelled]: symRoundedCancel,
}

/** Tile / filter order shown to the user: pipeline flow first, outcomes after */
export const STATUS_ORDER: (AiQueueStatus | 'all')[] = [
  'all',
  AiQueueStatus.Pending,
  AiQueueStatus.Processing,
  AiQueueStatus.AwaitingUserAction,
  AiQueueStatus.Completed,
  AiQueueStatus.Failed,
  AiQueueStatus.Cancelled,
]

export function fileIconFor(mimeType: string | null | undefined): string {
  if (!mimeType) return symRoundedDescription
  if (mimeType === 'application/pdf') return symRoundedPictureAsPdf
  if (mimeType.startsWith('image/')) return symRoundedImage
  return symRoundedDescription
}
